import { gqlGroupMember, gqlGroupOption } from './getGroupMember.api';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { GroupOptionsOverview } from '../../graphql/groups.datatypes';

export const gqlGroupBasicQuery = `
    id
    booking_form_url
    name
`;

export const gqlGroupForOverviewTabQuery = `
    id
    end_date
    tour_resource_id
    comp_ratio
    members {
        ${gqlGroupMember}
    }
    comp_dollar_value
    start_date
    admissions_cutoff
    start_date_additional
    end_date_additional
    booking_tool_edit_cutoff
    locked
    hasPrimaryLeader
    name
    description_resort
    description
    description_whats_included
    description_checkin
    tour {
        id
        internal_name
    }
    hotel {
        id
        internal_name
    }
    hotel_resource_id
    booking_form_url
    invoice_document_id
    documents {
        id
        title

        completed_documents {
            id
        }
    }
    editing_level
    booking_tool_edit_cutoff
    max_additional_nights
    convenience_fee
    credit_card_fee
    comp_final_value
    default_authorize_members
    disabled
`;

export const gqlGroupForDetailsTabQuery = `
    id
    locked
    hasPrimaryLeader
    hasLeader
    name
    description_resort
    description
    description_whats_included
    description_insurance
    description_checkin
    start_date
    end_date
    booking_form_url
    invoice_document_id
    editing_level
    admissions_cutoff
    booking_tool_edit_cutoff
    start_date_additional
    end_date_additional
    max_additional_nights
    convenience_fee
    credit_card_fee
    comp_dollar_value
    comp_ratio
    comp_final_value
    default_authorize_members
    disabled
    documents {
        id
        title
    }
    tour_resource_id
    tour {
        id
        internal_name
    }
    hotel_resource_id
    hotel {
        id
        internal_name
    }
`;

export const gqlGroupForBillingPartiesTabQuery = `
    id
    booking_form_url
    start_date
    end_date
`;

export const gqlGroupForRoomPartiesTabQuery = `
    id
    booking_form_url
`;

export const gqlGroupForMembersTabQuery = `
    id
    locked
    booking_form_url
`;

export const gqlGroupForGroupOverviewCardQuery = `
    id
    name
    start_date
    end_date
    admissions_cutoff
    comp_ratio
    comp_dollar_value
    convenience_fee
    outstandingBalance
    cancelled_members_count
    members_count
    performers_count
    primaryLeader {
        id
        first_name
        email
        group_role
        tour_role
    }

    members {
        id
        first_name
        last_name
        email
        group_role
        tour_role
    }
    tour {
        id
        internal_name
        display_name
    }
    hotel {
        id
        internal_name
        display_name
    }
`;

export const gqlGroupForHotelOverviewCardQuery = `
    id
    bookings {
        id
        roomParties {
            id
            hotel_resource_id
            hotel {
                id
                internal_name
                display_name
                roomResources {
                    id
                    internal_name
                    display_name
                }
            }
            roomResource {
                id
                room_resource_id
            }
            members {
                id
            }
        }
    }
`;

export const gqlGroupForOptionsOverviewCardQuery = `
    id
    internal_name
    display_name
    room_member_options_count
    room_options_count
    total_options_count
`;

interface GroupOptionsData {
    groupByRef: void
    getGroupOptions: GroupOptionsOverview[]
}

export const getGroupOptionsQuery = (groupId: number | null, query: string) => {
    const id = groupId ? groupId : -1;
    return useQuery<GroupOptionsData>(
        gql`
            query getGroupOptions($id: Int!){
                getGroupOptions(id: $id){
                    ${query}
                }
            }
        `,
        {
            variables: {id}
        }
    );
};

export const gqlGroupTotalsQuery = `
    id
    start_date
    end_date
    documents {
        id
        title
        completed_documents {
            id
        }
    }
    tour_resource_id
    booking_form_url
    booking_tool_edit_cutoff
    payment_schedule {
        id
    }
    cost
    outstandingBalance
    overduePayments
    credit_card_fee
    totalCreditCardFees
    tour {
        id
        comms_email_address
    }
`;

export const gqlGroupForAdminsTabQuery = `
    id
    bookings {
        id
        roomParties {
            id
            hotel_resource_id
            hotel {
                id
                internal_name
                display_name
                roomResources {
                    id
                    internal_name
                    display_name
                }
            }
            roomResource {
                id
                room_resource_id
            }
            members {
                id
            }
        }
    }
`;

export const gqlGroupOptionsQuery = `
    id
    options {
        ${gqlGroupOption}
    }
    tour {
        id
        internal_name
        display_name
    }
    hotel {
        id
        internal_name
        display_name
    }
    optionIds

`;
